// extracted by mini-css-extract-plugin
module.exports = {"modalCommon":"styles_modalCommon__2J9av","modalTitle":"styles_modalTitle__1GSOv","modalFooter":"styles_modalFooter__3K4Ms","buttonSubmit":"styles_buttonSubmit__8AcRK"};